import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  InputAdornment,
  Avatar,
  List,
  ListItem,
  Divider,
  CircularProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";

const CustomerSelectionModal = ({
  customers,
  onSelectCustomer,
  onAddNewCustomer,
  setSearchParams,
  isLoading,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [filteredCustomers, setFilteredCustomers] = useState([]);

  useEffect(() => {
    // Initialize with all customers
    setFilteredCustomers(customers);
  }, [customers]);

  const handleSearch = (event) => {
    const term = event.target.value;
    setSearchTerm(term);
    setSearchParams((prev) => ({ ...prev, searchQuery: term }));

    // if (term.trim() === "") {
    //   setFilteredCustomers(customers);
    // } else {
    //   const filtered = customers.filter(
    //     (customer) =>
    //       (customer.name &&
    //         customer.name.toLowerCase().includes(term.toLowerCase())) ||
    //       (customer.companyName &&
    //         customer.companyName.toLowerCase().includes(term.toLowerCase())) ||
    //       (customer.addresses &&
    //         customer.addresses.postal &&
    //         customer.addresses.postal
    //           .toLowerCase()
    //           .includes(term.toLowerCase()))
    //   );
    //   setFilteredCustomers(filtered);
    // }
  };

  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
    onSelectCustomer(customer);
  };

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name) return "??";

    const words = name.split(" ");
    if (words.length >= 2) {
      return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Function to generate a color based on name
  const getAvatarColor = (name) => {
    if (!name) return "#ccc";

    const colors = [
      "#1976d2", // blue
      "#388e3c", // green
      "#d32f2f", // red
      "#f57c00", // orange
      "#7b1fa2", // purple
      "#00796b", // teal
      "#c2185b", // pink
    ];

    const charCode = name.charCodeAt(0);
    return colors[charCode % colors.length];
  };

  // Get display name for customer
  const getDisplayName = (customer) => {
    if (customer.companyName) {
      return `${customer.companyName} (${customer.shortCode || ""})`;
    }
    return `${customer.name} (${customer.shortCode || ""})`;
  };

  return (
    <Box sx={{ width: "100%" }}>
      <TextField
        fullWidth
        placeholder="Search by company or ZIP code"
        value={searchTerm}
        onChange={handleSearch}
        variant="outlined"
        sx={{ mb: 3 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress size={60} />
        </Box>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="subtitle1" fontWeight="medium">
              Recent customers
            </Typography>
            <Button
              startIcon={<AddIcon />}
              color="primary"
              onClick={onAddNewCustomer}
            >
              Add new customer
            </Button>
          </Box>

          <RadioGroup
            value={selectedCustomer ? selectedCustomer.uuid : ""}
            onChange={(e) => {
              const customer = filteredCustomers?.find(
                (c) => c.uuid === e.target.value
              );
              handleCustomerSelect(customer);
            }}
            sx={{
              
            }}
          >
            <List sx={{ width: "100%" , px:0}}>
              {filteredCustomers?.map((customer, index) => (
                <React.Fragment key={customer.uuid}>
                  <ListItem alignItems="center" sx={{ py: 0.5 }}>
                    <FormControlLabel
                      value={customer.uuid}
                      control={<Radio />}
                      label={
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            sx={{
                              bgcolor: getAvatarColor(
                                customer.name || "Unknown"
                              ),
                              width: 36,
                              height: 36,
                              mr: 2,
                              fontSize: "0.875rem",
                            }}
                          >
                            {getInitials(customer.name || "Unknown")}
                          </Avatar>
                          <Typography variant="body1">
                            {getDisplayName(customer)}
                          </Typography>
                        </Box>
                      }
                      sx={{
                        width: "100%",
                        m: 0,
                        "& .MuiFormControlLabel-label": {
                          width: "100%",
                        },
                      }}
                    />
                  </ListItem>
                  {index < filteredCustomers.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </RadioGroup>
        </>
      )}
    </Box>
  );
};

export default CustomerSelectionModal;
